<template>
  <div class="updateemail ma-2">
    <div class="title">
      Email update confirmation
    </div>


    <v-layout row v-show="needEmail" class="justify-center">
      <v-flex class="xs12 sm6">
        <v-form v-on:submit.prevent="noop"
                ref="form"
                v-model="valid"
         >
         <br />
          Please confirm your email address:
          <v-text-field
            id="email"
            v-model="email"
            :rules="[rules.required, rules.email]"
            name="email"
            label="Email"
            color="red"/>

          <v-btn
            :disabled="!valid"
            color="success"
            @click="finishLogin">
              Complete Login
          </v-btn>
        </v-form>
      </v-flex>
    </v-layout>

    <div v-if="errMessage" class="error--text ">
       {{ errMessage }}
    </div>

    <div v-if="successMessage" class="success--text ">
       {{ successMessage }}
       <router-link :to="{name: 'Dashboard'}">Back to Dashboard</router-link>
    </div>

</div>

</template>

<script>

import {mapState} from 'vuex'
import utils from '../../utils.ts'
import firebase from 'firebase/app'

export default {
  name: 'UpdateEmail',
  components: {

  },
  data () {
    return {
      valid: false,
      errMessage: null,
      successMessage: null,
      needEmail: false,
      email: null,
      rules: {
        required: value => !!value || 'Required.',
        min: v => v.length >= 6 || 'Min 6 characters',
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return pattern.test(value) || 'Invalid e-mail.'
        }
      }
    }
  },
  mounted: function () {
    this.finishLogin()
  },
  methods: {
      doSignInWithEmail: async function (email) {

          try {
            // Construct the email link credential from the current URL.
            var credential = firebase.auth.EmailAuthProvider.credentialWithLink(
                email, window.location.href);

            // Re-authenticate the user with this credential.
            const userCred = await firebase.auth().currentUser.reauthenticateAndRetrieveDataWithCredential(credential)

            // The user is now successfully re-authenticated and can execute sensitive
            // operations.

            var paramsString = window.location.search;
            var searchParams = new URLSearchParams(paramsString);
            if (searchParams.has("newemail") === true) {
              const newEmail = searchParams.get('newemail')
              console.log(`Changing email: ${email} --> ${newEmail}`)
              await firebase.auth().currentUser.updateEmail(newEmail)
              this.successMessage = "Email was successfully changed."
            } else {
              this.errMessage = "Error: Missing the new email. Try again or contact SmartKidsMarket if this error persists."
            }
          } catch (err) {
            console.error("Error logging in: "+err)
            this.errMessage = err.message
          }

      },

      finishLogin: async function () {
        this.successMessage = false
        this.errMessage = false

        var paramsString = window.location.search;
        var searchParams = new URLSearchParams(paramsString);
        if (searchParams.has("newemail") === true) {
          console.log("NEW EMAIL is: "+searchParams.get('newemail'))
        } else {
          console.log("NO NEW EMAIL")
        };


        try {
          // Confirm the link is a sign-in with email link.
          if (firebase.auth().isSignInWithEmailLink(window.location.href)) {

            // Additional state parameters can also be passed via URL.
            // This can be used to continue the user's intended action before triggering
            // the sign-in operation.
            // Get the email if available. This should be available if the user completes
            // the flow on the same device where they started it.
            var email = window.localStorage.getItem('emailForSignIn');
            if (email) {
              this.doSignInWithEmail(email)
            } else if (this.email) {
              this.doSignInWithEmail(this.email)
            } else {
              // We need to get the email from the form.
              this.needEmail = true
            }
          } else {
            console.log("Error: not from link")
            this.errMessage = "This confirmation page is invalid right now. Try again or contact SmartKidsMarket if this error persists."
          }
      } catch (err) {
        console.error("Error signing in with email:"+err)
        this.errMessage = err.message
      }
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
